import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'

export const ErrorStateDisplay = () => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId="error-state"
      LottiePlayer={<Lottie src="connection-error" />}
      title={t('defaultError')}
      description={
        <>
          {t('requestErrors.comeBackLater')}{' '}
          <ExternalLink href={window.location.href}>
            {t('requestErrors.refreshPage')}
          </ExternalLink>
        </>
      }
    />
  )
}
